<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="4" :lg="7" :md="9" :sm="24">
            <j-dict-select-tag
              style="width: 100%"
              placeholder="请选择年级"
              v-model="queryParam.gradeId"
              dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
              :allowClear="false"
              :isShowEmpty="false"
              @select="(record) => selectTag('grade', record)"
            />
          </a-col>
          <a-col :xl="4" :lg="6" :md="9" :sm="24">
            <j-dict-select-tag
              style="width: 100%"
              placeholder="请选择班级"
              v-model="queryParam.id"
              :dictCode="
                'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
              "
              :async="true"
              :disabled="!queryParam.gradeId"
              :isShowEmpty="false"
              @select="(record) => selectTag('class', record)"
            />
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <school-class-modal ref="modalForm" @ok="modalFormOk"></school-class-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import SchoolClassModal from './modules/SchoolClassModal'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import {getAction} from '@/api/manage'

  export default {
    name: 'SchoolClassList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      SchoolClassModal,
      JSearchSelectTag
    },
    data () {
      return {
        description: 'school_class管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'年级名称',
            align:"center",
            dataIndex: 'gradeName'
          },
          {
            title:'班级名称',
            align:"center",
            dataIndex: 'name'
          },
          {
            title:'班主任名称',
            align:"center",
            dataIndex: 'teacherName'
          },
          {
            title:'排序',
            align:"center",
            dataIndex: 'sortOrder'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/aigoes/schoolClass/list",
          delete: "/aigoes/schoolClass/delete",
          deleteBatch: "/aigoes/schoolClass/deleteBatch",
          exportXlsUrl: "/aigoes/schoolClass/exportXls",
          importExcelUrl: "aigoes/schoolClass/importExcel",
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    /*watch: {
      'queryParam.gradeId': function (val) {
        console.log('年级变化--', val)
        if (val) {
          this.getStudentMood()
          this.getTableData()
          this.getSearchKeyword()
        }
      },
      'queryParam.id': function (val) {
        if (val == undefined) {
          this.currClassName = ''
          return
        }
        this.getSearchKeyword()
      },
    },*/
    methods: {
      selectTag(type, record) {
        console.log('选择标签', record, type)
        switch (type) {
          case 'grade':
            this.$set(this.queryParam, 'id', '')
            this.$set(this.queryParam, 'gradeId', record.value)
            this.currGradeName = record.text
            break
          case 'class':
            this.$set(this.queryParam, 'id', record.value)
            this.currClassName = record.text
            break
        }
        // this.$set(this.formData, 'name', record.text)
      },
      setDefaultGrade(record) {
        this.$set(this.queryParam, 'gradeId', record[0].value)
        this.currGradeName = record[0].title
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>